module.exports = __webpack_public_path__ + "img/dhonielle-clayton.93f026ba.png";